// import queryString from "query-string";
import React, { useContext } from "react";
import {
  CustomButton2,
  CustomDropdownFilter,
  CustomDropdownSearch,
  //   CustomRadioButtonGroup,
  //   DropDownSearchCities,
  //   DropDownSearchProvinces,
  //   DropDownSearchSuperAgent,
} from "../../../../../../components";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import "./index.scss";
import { useQuery } from "react-query";
import api from "../../../../../../api";
import values from "../../../../../../values";
import Context from "../../../../../../context";
import {
  ICityItem,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { useTranslation } from "react-i18next";

const FilterSuperAgent = () => {
  // ============================== Value Validation ================================

  const { requestSuperAgent, setRequestSuperAgent } = React.useContext(
    Context.SuperAgentProvinceScreen
  );

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
    api.get.common.getAllProvince()
  );
  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, requestSuperAgent?.filters?.province],
  //   () =>
  //     api.get.common.getAllCity({
  //       provinceCode: requestSuperAgent?.filters?.province?.Code,
  //     })
  // );
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  const userType = Cookies.get(constants.USER.TYPE);

  const { t } = useTranslation();

  // ================================== JSX Content ================================

  return (
    <div className="filter-container">
      <CustomDropdownFilter title={t("filter")} hoverTitle={t("filter")}>
        {/* <p className="filter-labels">وضعیت آژانس:</p> */}
        {/* <CustomRadioButtonGroup
          menus={values.radioButtonItems.rbiIsBlock}
          selected={selectedFilters?.isBlock}
          onClick={(selected: iItem | null) => setSelectedFilters({...selectedFilters, isBlock: selected})}
        /> */}
        {/* <p className="filter-labels">وضعیت تایید:</p> */}
        {/* <CustomRadioButtonGroup
          menus={values.radioButtonItems.rbiIsApproved}
          selected={selectedFilters?.isApproved}
          onClick={(selected: iItem | null) => setSelectedFilters({...selectedFilters, isApproved: selected})}
        /> */}

        <p className="filter-labels">{t("province")}:</p>
        <CustomDropdownSearch
          items={getAllProvince?.data?.result}
          itemName="Name"
          defaultItem={requestSuperAgent?.filters?.province}
          onSelectItem={(event: IProvinceItem) =>
            setRequestSuperAgent({
              ...requestSuperAgent,
              filters: {
                ...requestSuperAgent?.filters,
                province: event,
                city: undefined,
              },
            })
          }
          placeHolder={t("selectProvince")}
          isLoading={getAllProvince.isLoading}
        />

        {/* <p className="filter-labels">شهر:</p>
        <CustomDropdownSearch
          items={getAllCity?.data?.result}
          itemName="Name"
          defaultItem={requestSuperAgent?.filters?.city}
          onSelectItem={(event: ICityItem) =>
            setRequestSuperAgent({
              ...requestSuperAgent,
              filters: {
                ...requestSuperAgent?.filters,
                city: event,
              },
            })
          }
          placeHolder="انتخاب شهر"
          isLoading={getAllCity.isLoading}
        /> */}
        {userType === "ADMIN" && (
          <>
            <p className="filter-labels">انتخاب اتحادیه و زیر مجموعه:</p>
            {/* <DropDownSearchSuperAgent
              defaultValue={selectedFilters?.superAgent?.name}
              onChangeSuperAgent={(selected: iItem | null) => {
                setSelectedFilters({...selectedFilters, superAgent: selected});
              }}
            /> */}
          </>
        )}
        <div className="filter-footer">
          <CustomButton2
            title={t("reset")}
            onClick={() => {
              setRequestSuperAgent({
                limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
                page: 1,
              });
            }}
            type="primary"
          />
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ?? -----------------------------------------------------------------------------------------------------------
  // ??                                             End JSX Content
  // ?? ===========================================================================================================
};

export default FilterSuperAgent;
